import { AuditResourceType } from '_lib/api';
import { useAppDispatch } from '_store';
import { devicesSagas } from '_store/devices/sagas';
import { devicesSelector } from '_store/devices/selectors';
import { useLocalization } from '@fluent/react';
import { CardContent, Divider } from '@material-ui/core';
import React, { FC, useState } from 'react';
import { useSelector } from 'react-redux';

import { useRolePermissions } from '../../../hooks/useRolePermissions';
import AuditHistorySection from '../../items/AuditHistory';
import MessageDialog from '../../items/MessageDialog';
import CardListItem from './Card';

export interface DeviceLayoutSingleProps {
  id: string;
  onUpdateRsu?: (idExpanded: string) => void;
}

// detail card of selected RSU
const DeviceLayoutSingle: FC<DeviceLayoutSingleProps> = ({ id, onUpdateRsu }) => {
  const { l10n } = useLocalization();
  const devices = useSelector(devicesSelector);
  const device = devices.find((d) => d.id === id);
  const dispatch = useAppDispatch();
  const { canManageRsu, blockedActionMode } = useRolePermissions();

  const [showMessage, setShowMessage] = useState({
    active: false,
    typeAction: 'delete',
    idToDelete: null,
    typeEvent: 'rsu',
  });
  const writeBlockedMessage = l10n.getString('forms-rbac-readonly-action-denied');

  if (!device) {
    return <>Could not find RSU</>;
  }

  const onMessageLeaveConfirmed = (type: string) => {
    if (type === 'confirm') {
      dispatch(devicesSagas.actions.deleteRSU(showMessage.idToDelete));
    }

    setShowMessage((sm) => ({
      ...sm,
      active: false,
      idToDelete: null,
    }));
  };

  const onDeleteRsu = (idToDelete) => {
    setShowMessage((sm) => ({
      ...sm,
      active: true,
      idToDelete,
      count: 1,
    }));
  };

  return (
    <>
      {showMessage.active === true ? (
        <MessageDialog statusMessage={showMessage} onCloseDialog={onMessageLeaveConfirmed} />
      ) : null}
      <CardListItem
        device={device}
        asCard={false}
        text={device.name}
        onUpdate={() => onUpdateRsu?.(device.id)}
        onDelete={() => onDeleteRsu(device.id)}
        writeAllowed={canManageRsu}
        blockedActionMode={blockedActionMode}
        blockedMessage={writeBlockedMessage}
      />

      {/* Only here, never in Card/Details: that one also renders every row of the RSU list */}
      <CardContent style={{ paddingTop: 0 }}>
        <Divider />
        <AuditHistorySection
          key={device.id}
          resourceType={AuditResourceType.RSU}
          resourceId={device.id}
        />
      </CardContent>
    </>
  );
};

export default React.memo(DeviceLayoutSingle);
